module.exports = __webpack_public_path__ + "img/五角星.a90fca60.png";